import { confidenceFeatures } from "@/mocks/confidenceFeatures";

export default function ConfidenceSection() {
  return (
    <section className="w-full bg-white py-12 md:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <h2 className="font-display text-xl md:text-2xl font-bold text-stone-800 text-center tracking-wide uppercase">
          放心購物與銷售
        </h2>

        <div className="mt-8 md:mt-10 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {confidenceFeatures.map((feature) => (
            <div key={feature.title} className="flex items-start gap-4">
              <div className="w-14 h-14 rounded-full bg-stone-50 flex items-center justify-center shrink-0">
                <i className={`${feature.icon} text-2xl text-rose-700`} />
              </div>
              <div>
                <h3 className="font-body text-xs font-bold text-stone-800 uppercase tracking-wider">
                  {feature.title}
                </h3>
                <p className="font-body text-xs text-stone-500 mt-1.5 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}